import En from '@bryntum/schedulerpro/locales/schedulerpro.locale.En.js';

const localeGBPartial = {
  localeName: "Gb",
  localeDesc: "British English",
  NumberFormat: {
    locale: "en-GB",
    currency: "GBP"
  },
  DateHelper: {
    locale: "en-GB",
    weekStartDay: 0,
    nonWorkingDays: {
      0: true,
      6: true
    },
    weekends: {
      0: true,
      6: true
    },
    unitNames: [{
      single: "millisecond",
      plural: "ms",
      abbrev: "ms"
    }, {
      single: "second",
      plural: "seconds",
      abbrev: "s"
    }, {
      single: "minute",
      plural: "minutes",
      abbrev: "min"
    }, {
      single: "hour",
      plural: "hours",
      abbrev: "h"
    }, {
      single: "day",
      plural: "days",
      abbrev: "d"
    }, {
      single: "week",
      plural: "weeks",
      abbrev: "w"
    }, {
      single: "month",
      plural: "months",
      abbrev: "mon"
    }, {
      single: "quarter",
      plural: "quarters",
      abbrev: "q"
    }, {
      single: "year",
      plural: "years",
      abbrev: "yr"
    }, {
      single: "decade",
      plural: "decades",
      abbrev: "dec"
    }],
    unitAbbreviations: [
      ["mil"],
      ["s", "sec"],
      ["m", "min"],
      ["h", "hr"],
      ["d"],
      ["w", "wk"],
      ["mo", "mon", "mnt"],
      ["q", "quar", "qrt"],
      ["y", "yr"],
      ["dec"]
    ],
    parsers: {
      L: "DD/MM/YYYY",
      LT: "HH:mm A"
    },
  }
};

export default (() => {

  // Merged Locale
  const newGBLocale = Object.assign({}, En, {
    localeName: localeGBPartial.localeName,
    localeDesc: localeGBPartial.localeDesc
  });

  // Merge NumberFormat and DateHelper
  return {
    ...newGBLocale,
    NumberFormat: {...newGBLocale.NumberFormat, ...localeGBPartial.NumberFormat},
    DateHelper: {...newGBLocale.DateHelper, ...localeGBPartial.DateHelper}
  };
})();
